import { render, staticRenderFns } from "./VillagesEdit.vue?vue&type=template&id=c5431a3a&"
import script from "./VillagesEdit.vue?vue&type=script&lang=js&"
export * from "./VillagesEdit.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports